__turbopack_context__.v({
  "className": "barlow_condensed_bc2a234f-module__S4wH0a__className",
  "variable": "barlow_condensed_bc2a234f-module__S4wH0a__variable",
});
